import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Check from "@mui/icons-material/Check";
// import Submit from "@mui/icons-material/ArrowUpward";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import axios from "axios";
import "./HomeHeroSection.css";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const HomeHeroSection = () => {
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const storedAccessToken = localStorage.getItem("AccessToken");

    if (storedAccessToken) setAccessToken(storedAccessToken);
  }, []);

  const navigate = useNavigate();

  const [loaderSubmit, setloaderSubmit] = useState(false);
  const [next, setnext] = useState(0);
  const [selectedItem, setselectedItem] = useState([]);
  const [todayLookSelectedItem, settodayLookSelectedItem] = useState([]);
  const [contrastLookSelectedItem, setcontrastLookSelectedItem] = useState([]);
  const [checkForSelectedItem, setcheckForSelectedItem] = useState(false);
  const [todayLook, settodayLook] = useState([
    { id: 1, name: "party", status: false },
    { id: 2, name: "family", status: false },
    { id: 3, name: "beach", status: false },
    { id: 4, name: "hills", status: false },
    { id: 5, name: "office", status: false },
    { id: 6, name: "wedding", status: false },
    { id: 7, name: "western", status: false },
    { id: 8, name: "northern", status: false },
  ]);

  const [contrastLook, setcontrastLook] = useState([
    { id: 1, name: "vibrant", status: false },
    { id: 2, name: "natural", status: false },
    { id: 3, name: "minimal", status: false },
    { id: 4, name: "fair", status: false },
  ]);

  const [makeUpItems, setmakeUpItems] = useState([
    { id: 1, name: "lipstick", status: false },
    { id: 2, name: "eyeliner", status: false },
    { id: 3, name: "eyeshadow", status: false },
    { id: 4, name: "foundation", status: false },
    { id: 5, name: "powder blush", status: false },
    { id: 6, name: "cream blush", status: false },
  ]);

  const makeUpHeadings = [
    {
      heading: "Hey, How do you want to look today ?",
      sunHeading: "Select items you’d like to see in your makeup!",
    },
    {
      heading: "Hey, How do you want to look today ?",
      sunHeading: "Select items you’d like to see in your makeup!",
    },
    {
      heading: "Hey, How do you want to look today?",
      sunHeading: "Select items you’d like to see in your makeup!",
    },
  ];

  const handleTodayLookButton = (id, itemName) => {
    if (todayLookSelectedItem.includes(itemName)) {
      // Deselect if already selected
      settodayLookSelectedItem([]);
      setcheckForSelectedItem(false);
    } else {
      // Clear previous selection and add the new one
      settodayLookSelectedItem([itemName]);
      setcheckForSelectedItem(true);
    }

    // Update the todayLook state to ensure only one item is active
    const newData = todayLook.map((item) => ({
      ...item,
      status: item.id === id ? !item.status : false, // Select only the clicked item
    }));

    settodayLook(newData);
  };

  const handleContrastLook = (id, itemName) => {
    if (contrastLookSelectedItem.includes(itemName)) {
      // Deselect if already selected
      setcontrastLookSelectedItem([]);
      setcheckForSelectedItem(false);
    } else {
      // Clear previous selection and add the new one
      setcontrastLookSelectedItem([itemName]);
      setcheckForSelectedItem(true);
    }

    // Update the contrastLook state to ensure only one item is active
    const newData = contrastLook.map((item) => ({
      ...item,
      status: item.id === id ? !item.status : false, // Select only the clicked item
    }));

    setcontrastLook(newData);
  };

  const handleButton = (id, itemName) => {
    if (!selectedItem.includes(itemName)) {
      setselectedItem([...selectedItem, itemName]);
      setcheckForSelectedItem(true);
    }

    if (selectedItem.includes(itemName) && checkForSelectedItem) {
      const newData = selectedItem.filter((item) => item !== itemName);
      setselectedItem(newData);
    }

    const newData = makeUpItems.map((item) => {
      if (item.id === id) {
        if (item.status === true) {
          return {
            ...item,
            status: false,
          };
        } else {
          return {
            ...item,
            status: true,
          };
        }
      }
      return item;
    });

    setmakeUpItems(newData);
  };

  const hadleTodayLookData = () => {
    if (todayLookSelectedItem.length !== 0) {
      console.log(todayLookSelectedItem);
      setnext((prev) => prev + 1);
    } else console.log("Please select the items!");
  };
  const hadleContrastLookData = () => {
    if (contrastLookSelectedItem.length !== 0) {
      console.log(contrastLookSelectedItem);
      setnext((prev) => prev + 1);
    } else console.log("Please select the items!");
  };

  const hadleSubmitData = async () => {
    if (
      todayLookSelectedItem.length !== 0 &&
      contrastLookSelectedItem.length !== 0 &&
      selectedItem.length !== 0
    ) {
      const formData = {
        look: todayLookSelectedItem[0],
        style: contrastLookSelectedItem[0],
        subcategories: [...selectedItem],
      };
      console.log(formData);
      setloaderSubmit(true);
      let url = `${process.env.REACT_APP_API_KEY}/recommendation/filtered_recommend_top/`;

      try {
        const response = await axios.post(url, formData, {
          headers: { "Content-Type": "application/json" },
        });
        setloaderSubmit(false);
        console.log("response ", response.data);
        navigate(`/${accessToken}/Skin-Tone Analyzer`, {
          state: {
            data: response.data.recommended_products.recommended_products,
          },
        });
      } catch (error) {
        console.log("error messgage : ", error);
      }
    } else console.log("Please select the items!");
  };

  const hadleMakeUpItems = () => {
    if (selectedItem.length !== 0) {
      console.log(selectedItem);

      // setnext(0);
      hadleSubmitData();
    } else console.log("Please select the items!");
  };

  return (
    <>
      <div className="heroSection">
        {/* <img src={heroSectionImage} alt="heroSectionImage" /> */}

        <div className="left">
          <div className="makeupItemSelect">
            <h5>{makeUpHeadings[next].heading}</h5>
            <p>{makeUpHeadings[next].sunHeading}</p>

            <div className="buttonsContainer">
              {next === 0 &&
                todayLook.map((item, i) => {
                  return (
                    <Button
                      key={item.id}
                      className="selectableButton"
                      variant="contained"
                      endIcon={item.status && <Check />}
                      sx={{
                        width: "35%", // or your required width
                        backgroundColor: "white", // no background
                        color: "black", // or any preferred text color
                        fontFamily: "Roboto",
                        borderRadius: "50px",
                        letterSpacing: "1px",
                        textTransform: "lowercase",
                        boxShadow: "none", // remove button shadow
                        "&:hover": {
                          backgroundColor: "white", // no bg on hover
                          color: "black", // retain same text color
                          boxShadow: "none",
                        },
                        "&:active": {
                          backgroundColor: "white", // no bg on click
                          boxShadow: "none",
                        },
                        "&:focus": {
                          backgroundColor: "white", // no focus bg
                          boxShadow: "none",
                        },
                      }}
                      onClick={() => handleTodayLookButton(item.id, item.name)}
                    >
                      {item.name}
                    </Button>
                  );
                })}
              {next === 1 &&
                contrastLook.map((item, i) => {
                  return (
                    <Button
                      key={item.id}
                      className="selectableButton"
                      variant="contained"
                      endIcon={item.status && <Check />}
                      sx={{
                        width: "35%", // or your required width
                        backgroundColor: "white", // no background
                        color: "black", // or any preferred text color
                        fontFamily: "Roboto",
                        borderRadius: "50px",
                        letterSpacing: "1px",
                        textTransform: "lowercase",
                        boxShadow: "none", // remove button shadow
                        "&:hover": {
                          backgroundColor: "white", // no bg on hover
                          color: "black", // retain same text color
                          boxShadow: "none",
                        },
                        "&:active": {
                          backgroundColor: "white", // no bg on click
                          boxShadow: "none",
                        },
                        "&:focus": {
                          backgroundColor: "white", // no focus bg
                          boxShadow: "none",
                        },
                      }}
                      onClick={() => handleContrastLook(item.id, item.name)}
                    >
                      {item.name}
                    </Button>
                  );
                })}
              {next === 2 &&
                makeUpItems.map((item, i) => {
                  return (
                    <Button
                      key={item.id}
                      className="selectableButton"
                      variant="contained"
                      endIcon={item.status && <Check />}
                      sx={{
                        width: "35%", // or your required width
                        backgroundColor: "white", // no background
                        color: "black", // or any preferred text color
                        fontFamily: "Roboto",
                        borderRadius: "50px",
                        letterSpacing: "1px",
                        textTransform: "lowercase",
                        boxShadow: "none", // remove button shadow
                        "&:hover": {
                          backgroundColor: "white", // no bg on hover
                          color: "black", // retain same text color
                          boxShadow: "none",
                        },
                        "&:active": {
                          backgroundColor: "white", // no bg on click
                          boxShadow: "none",
                        },
                        "&:focus": {
                          backgroundColor: "white", // no focus bg
                          boxShadow: "none",
                        },
                      }}
                      onClick={() => handleButton(item.id, item.name)}
                    >
                      {item.name}
                    </Button>
                  );
                })}
            </div>
            <div className="submitButtonContainer">
              <Button
                className="selectableButton"
                variant="contained"
                startIcon={<KeyboardBackspaceIcon />}
                // disabled={true}
                // backgroundColor: "#B2435E",
                sx={{
                  width: "31%", // or your required width
                  backgroundColor: next === 0 ? "gray" : "#B2435E",
                  color: next === 0 ? "white" : "black", // or any preferred text color
                  fontFamily: "Roboto",
                  borderRadius: "50px",
                  letterSpacing: "1px",
                  textTransform: "lowercase",
                  boxShadow: "none", // remove button shadow
                  "&:hover": {
                    backgroundColor: next === 0 ? "gray" : "#B2435E",
                    color: next === 0 ? "white" : "black",
                    boxShadow: "none",
                  },
                }}
                onClick={() => next !== 0 && setnext((prev) => prev - 1)}
              >
                back
              </Button>
              <Button
                className="selectableButton"
                variant="contained"
                endIcon={loaderSubmit ? <></> : <ArrowRightAltIcon />}
                sx={{
                  width: "33%", // or your required width
                  backgroundColor: "#B2435E", // no background
                  color: "black", // or any preferred text color
                  fontFamily: "Roboto",
                  borderRadius: "50px",
                  letterSpacing: "1px",
                  textTransform: "lowercase",
                  boxShadow: "none", // remove button shadow
                  "&:hover": {
                    backgroundColor: "#B2435E", // no bg on hover
                    color: "black", // retain same text color
                    boxShadow: "none",
                  },
                  "&:active": {
                    backgroundColor: "#B2435E", // no bg on click
                    boxShadow: "none",
                  },
                  "&:focus": {
                    backgroundColor: "#B2435E", // no focus bg
                    boxShadow: "none",
                  },
                }}
                onClick={
                  next === 0
                    ? hadleTodayLookData
                    : next === 1
                    ? hadleContrastLookData
                    : hadleMakeUpItems
                }
              >
                {next > 1 ? "submit" : "next"}
                {loaderSubmit && (
                  <CircularProgress size={16} sx={{ ml: 1 }} color="inherit" />
                )}
              </Button>
            </div>
          </div>
        </div>
        {/* <div className="right">
          <p className="aura">
            YOUR
            <h1>
              <span>A</span>URA
            </h1>
          </p>
          <p className="intelligence">
            OUR
            <h1>
              <span>I</span>NTELLIGENCE
            </h1>
          </p>
          <div className="buttonsExplore">
            <button className="exploreButton">LET’S EXPLORE</button>
            <button className="learnMore">LEARN MORE</button>
          </div>
        </div> */}
        <div className="right">
          {/* New Grid Structure */}
          <div className="hero-text-grid">
            <span className="prefix-text">YOUR</span>
            <h1>
              <span>A</span>URA
            </h1>

            <span className="prefix-text">OUR</span>
            <h1>
              <span className="i-verdana">I</span>NTELLIGENCE
            </h1>
          </div>

          <div className="buttonsExplore">
            <button className="exploreButton">LET'S EXPLORE</button>
            <button className="learnMore">LEARN MORE</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeHeroSection;
